import { Injectable } from "@angular/core";

@Injectable()
export class ConstantMessageService {
    getStatus(status: boolean): string {
        return status ? 'ACTIVADO' : 'DESACTIVADO';
    }
}
